module.exports = {
      id: "charge-middle-usage",
      viewBox: "0 0 17 12",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#charge-middle-usage",
      toString: function () {
        return this.url;
      }
    }